module.exports = __webpack_public_path__ + "img/626262_9E9E9E_848484_262626-256px.2b33e3c0.png";